const ActionType = {
  TABLE_DATA: "TableAction.TABLE_DATA",
  TABLE_LOADING: "TableAction.TABLE_LOADING",
  TABLE_ERROR: "TableAction.TABLE_ERROR",
  TABLE_ACTION_ERROR: "TableAction.TABLE_ACTION_ERROR",
};

export default ActionType;